import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  BooleanField,
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  Create,
  EditButton,
  DeleteButton,
  Filter,
  SearchInput,
  Pagination,
} from 'react-admin';

const UserFilter = (props) => (
  <Filter {...props}>
    {/* Single search: matches email OR username (Ransack email_or_username_cont).
        source uses [cont] so the dataProvider emits q[email_or_username_cont]. */}
    <SearchInput source="email_or_username[cont]" alwaysOn placeholder="Search email or username" />
  </Filter>
);

export const UserList = (props) => (
  <List {...props} filters={<UserFilter />} perPage={25} pagination={<Pagination />}>
    <Datagrid rowClick="edit">
      <TextField source="username" />
      <TextField source="first_name" />
      <TextField source="last_name" />
      <EmailField source="email" />
      <TextField source="role" />
      <BooleanField source="is_admin" />
      <BooleanField source="can_use_profile_agency" />
      <TextField source="initials" />
      <TextField source="created_at" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const UserEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="username" disabled />
      <TextInput source="first_name" />
      <TextInput source="last_name" />
      <TextInput source="email" />
      <TextInput source="role" />
      <BooleanInput source="is_admin" />
      <TextInput source="color" />
      <TextInput source="initials" />
      <TextInput source="address" />
      <BooleanInput source="is_public" />
      <BooleanInput source="is_teacher" />
      <BooleanInput source="can_use_profile_agency" />
      <TextInput source="locale" />
    </SimpleForm>
  </Edit>
);

// Custom edit controller that uses external_id for API calls
export const UserEditController = (props) => {
  const record = props.record;
  if (record && record.external_id) {
    // Replace the id with external_id for API calls
    props.id = record.external_id;
  }
  return <Edit {...props} />;
};

export const UserCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="username" />
      <TextInput source="first_name" />
      <TextInput source="last_name" />
      <TextInput source="email" />
      <TextInput source="role" />
      <BooleanInput source="is_admin" />
      <TextInput source="color" />
      <TextInput source="initials" />
    </SimpleForm>
  </Create>
);
